/* eslint-disable import/no-anonymous-default-export */
export default {
  translations: {
    HOME: {
      INITIAL_PAGE: "Página Inicial",
      UPDATED_AT: "Atualizado em",
      EXPANDED_VIEW: "Visão expandida",
      QUICK_ACCESS: "Acesso Rápido",
      SUPORT: "Suporte",
      CALL_CENTER: "Central de Atendimento",
      VEHICLE_ASSISTANCE: "Assistência de Veículos:",
      DOES_NOT_HAVE: "ainda não tem?",
      CHAT_WITH_COMMERCIAL: "Conheça e converse com nosso comercial.",
      GENERAL_DATA: "Dados Gerais",
      SEARCH: "Buscar",
      COMMERCIAL: "Comercial",
      LANGUAGE: "Idioma",
      QUICK_CONTACT: "Contato rápido",
      CONTACT_REGIONAL: "Regional",
      CONTACT_COMERCIAL: "Comercial",
      CONTACT_CENTRAL: "Central de Emergência 24h",
      VEHICLE_NOT_SELECTED: "Nenhum veículo selecionado",
    },
    TITLE: {
      DASHBOARD: "Dashboard Gerencial",
      FILTERS: "Filtros",
      FILTER_CHARTS: "Filtro de gráficos",
      FILTER_PERIODS: "Período de busca",
      FILTER_GROUPS: "Grupo de veículos",
      MY_FLEET: "Minha Frota",
      MAP: "Mapa",
      MAIN_GRID: "Painel Geral (Grid)",
      DETAILED_POSITIONS: "Posições Detalhadas",
      DRIVERS_REGISTERED: "Motoristas Cadastrados",
      DRIVER_REGISTER: "Cadastro de Motorista",
      VEHICLES: "Veículos",
      LOGS: "Logs",
      CLIENT_SEARCH: "Pesquisa de clientes",
      NEARBY_VEHICLES: "Veículos nas proximidades",
    },
    MENU: {
      HOME: "Home",
      RASTREAMENTO: "Rastreamento",
      GRUPOS: "Grupos",
      CONTROLE: "Controle",
      ATENDIMENTO: "Atendimento",
      RELATÓRIOS: "Relatórios",
      CADASTRO: "Cadastro",
      MANUTENÇÃO: "Manutenção",
      SISTEMA: "Sistema",
      "Cadastro de Grupos": "Cadastro de Grupos",
      "Cadastro de Veículos": "Cadastro de Veículos",
      "Motoristas Cadastrados": "Motoristas Cadastrados",
      "Veículos vinculados": "Veículos vinculados",
      "Vincular usuários aos grupos": "Vincular usuários aos grupos",
      "Pontos de Visita": "Pontos de Visita",
      "Cerca Eletrônica": "Cerca Eletrônica",
      "Área de Risco": "Área de Risco",
      "Minha Frota": "Minha Frota",
      "Posições Detalhadas": "Posições Detalhadas",
      "Radar": "Radar",
      "Veículo mais próximo": "Veículo mais próximo",
      "Deslocamento": "Deslocamento",
      "Posicionamento": "Posicionamento",
      "Distância Percorrida": "Distância Percorrida",
      "Visitas por veículos": "Visitas por veículos",
      "Veículos em visitas": "Veículos em visitas",
      "Controle de Velocidade": "Controle de Velocidade",
      "Protocolos de Atendimento": "Protocolos de Atendimento",
      "Logs": "Logs",
      "Veículo/Apelido": "Veículo/Apelido",
      "Dashboard de gestão": "Dashboard de gestão",
      "Perfil": "Perfil",
      "Alterar Senha": "Alterar Senha",
      "Visualizar Cliente": "Visualizar Cliente",
      "Usuários do Cliente": "Usuários do Cliente",
    },
    DASHBOARD_CHARTS: {
      VEHICLE_STATUS: "Status dos Veículos",
      DRIVER_RANKING: "Ranking de Motoristas",
      GREATER_CIRCULATION: "Maior Circulação",
      GREATER_IDLENESS: "Maior Ociosidade",
      IDLENESS_DESCRIPTION_ENGINE: "Motor Ligado",
      IDLENESS_DESCRIPTION_IDLE: "Parado",
      IDLENESS_DESCRIPTION_OFF: "Motor Desligado",
      OUTSIDE_WORK_HOURS: "Fora do Horário Comercial",
      OUTSIDE_WORK_HOURS_DESCRIPTION: "Fora do Horário Comercial",
      INSIDE_WORK_HOURS_DESCRIPTION: "Dentro do Horário Comercial",
      WEEKLY_CIRCULATION: "Circulação Semanal",
      SPEED_LIMIT: "Limite de Velocidade",
      TRANSIT_FINES: "Multas de Trânsito",
      SPEED_ABOVE_COMPANY_LIMIT: "Velocidade acima do limite da empresa",
      SPEED_UP_TO_20_PERCENT_ABOVE: "Velocidade até 20% acima do limite da via (infração média)",
      SPEED_BETWEEN_20_50_PERCENT_ABOVE: "Velocidade entre 20% e 50% acima do limite da via (infração grave)",
      SPEED_ABOVE_50_PERCENT: "Velocidade acima de 50% do limite da via (infração gravíssima)",
    },
    DASHBOARD: {
      ACTIVE_VEHICLES: "Veículos Ativos",
      TOTAL_ODOMETER: "Odômetro Total",
      WORK_HOURS_DISTANCE: "Km Horário Comercial",
      OUTSIDE_WORK_HOURS_DISTANCE: "Km Fora do Horário Comercial",
      ENGINE_TIME: "Tempo de Uso",
      IDLE_TIME: "Tempo Ocioso",
      OFF_TIME: "Tempo Desligado",
      SPEED_LIMIT_DISTANCE: "Ocorrências Acima do Limite da Via",
      COMPANY_SPEED_LIMIT_DISTANCE: "Ocorrências Acima do Limite da Empresa",
      TOTAL_FINES: "Multas",
    },
    TABLE_FINES: {
      DRIVER: "Motorista",
      DATE: "Data",
      VALUE: "Valor (R$)",
      PLATE: "Placa",
    },
    FLEET: {
      BACK: "Voltar",
      MAP: "Mapa",
      GRID_AND_MAP: "Grid + Mapa",
      ACTIONS: "Ações",
      VIEW_MAP: "Ver mapa",
      OPEN_GOOGLE_MAPS: "Abrir Google Maps",
      BLOCK: "Bloqueio",
      ANCHOR: "Âncora",
      COMMANDS: "Comandos",
      CREATE_VISIT_POINT: "Criar Ponto de Visita",
      AVAILABLE_COMMANDS: "Comandos disponíveis",
      COMMAND_SENT: "Comando enviado",
      VEHICLE: "Veículo",
      THIS_VEHICLE_HAS_BLOCK: "Este veículo possui bloqueio",
      COMMAND_HISTORY: "Histórico de comandos",
      HISTORY: "Histórico",
      NO_DATA_FOUND: "Nenhum dado encontrado para o período selecionado",
    },
    IGNITION: {
      ON: "Ligado",
      OFF: "Desligado",
    },
    SEARCH: {
      SEARCH: "Busca",
      INITIAL_DATE_TIME: "Data e hora inicial",
      FINAL_DATE_TIME: "Data e hora final",
      UPDATE_PAGE: "Atualizar página",
      UPDATE: "Atualizar",
      INITIAL_TIME: "Horário Inicial",
      FINAL_TIME: "Horário Final",
    },
    MAINTENANCE: {
      MAINTENANCE: "Manutenção",
      REGISTER: "Registrar",
      REMOVE: "Retirar",
      REGISTER_MAINTENANCE: "Registrar Manutenção",
      REMOVE_MAINTENANCE: "Retirar Manutenção",
    },
    COMMANDS: {
      SEND_COMMANDS: "Enviar Comandos",
      COMMANDS: "Comandos",
      COMMAND_HISTORY: "Histórico de Comandos",
      ANCHOR: "Âncora",
      BLOCK: "Bloqueio",
      UNLOCK: "Desbloqueio",
    },
    REPORTS: {
      REPORT_REQUEST: "Solicitação de relatório",
      NO_DATA_IN_RESPONSE: "A resposta não contém os dados necessários.",
      FILTER_VALIDATION: "Validação dos Filtros",
      ERROR_FETCHING_REPORT: "Erro ao buscar dados do relatório",
      SELECT_VEHICLE: "Selecione um veículo",
      VEHICLE_ACTIVITY_TITLE: "Relatório de Atividade Veicular",
    },
    REPORT_COLUMNS: {
      START: "Início",
      START_LOCATION: "Local Início",
      END: "Fim",
      END_LOCATION: "Local Fim",
      TOTAL_DISTANCE: "Distância total",
      TRAVEL_TIME: "T percurso",
      REST_TIME: "T descanso",
      AVG_SPEED: "Ve média",
      MAX_SPEED: "V máxima",
      DRIVER: "Motorista",
      PLATE: "Placa",
      DISTANCE: "Distância",
      DAY_OF_WEEK: "Dia da Semana",
      DATE: "Data",
      IGNITION_ON: "Início",
      ENGINE_TIME: "Tempo ligado",
      SAMPLES_ABOVE_SPEED: "Amostras acima da velocidade filtrada",
      SAMPLES_WITHIN_SPEED: "Amostras dentro da velocidade filtrada",
      DATE_TIME: "Data/Hora",
      STATUS: "Status",
      IGNITION: "Ignição",
      EVENT: "Evento",
      SPEED: "Velocidade",
      LOCATION: "Localização",
      DURATION: "Duração",
      TYPE: "Tipo",
      PROTOCOL: "Protocolo",
      DESCRIPTION: "Descrição",
      OPENING_DATE: "Data de Abertura",
      SERVICE_DATE: "Data de Atendimento",
      CLOSING_DATE: "Data de Fechamento",
      ATTENDANT: "Atendente",
      PROTOCOL_ID: "Protocolo",
      VEHICLE_ID: "Veículo",
      ALERT: "Alerta",
      TOTAL_ROWS: "Total de linhas",
      TOTAL_PAGES: "Total de páginas",
      PAGE_NUMBER: "Número da página",
      PAGE_SIZE: "Tamanho da página",
      ACCOUNT: "Conta",
      USER: "Usuário",
      MAIN_BATTERY: "Bat. Veículo",
      BACKUP_BATTERY: "Bat. Rastreador",
    },
    ALERTS: {
      TITLE: "Alertas",
      DETAILS_BUTTON: "Ver detalhes",
      MODAL_TITLE: "Detalhes do Alerta",
      COLUMNS: {
        PLATFORM: "Plataforma",
        PROTOCOL_ID: "Protocolo",
        CLIENT: "Cliente",
        CLIENT_ID: "ID do Cliente",
        DOCUMENT: "Documento",
        EVENT_DATE: "Data do Evento",
        SUBTYPE: "Subtipo",
        VEHICLE_ID: "Veículo",
        PLATE: "Placa",
        LOCATION: "Localização",
        STATUS: "Status",
        LAST_UPDATE: "Última Atualização",
        PHONE: "Telefone",
        PHONE_2: "Telefone 2",
      },
      FILTERS: {
        START_DATE: "Início",
        END_DATE: "Fim",
        SEARCH: "Buscar",
      },
      MODAL: {
        INTERACTIONS_TITLE: "Interações",
        EMPTY_INTERACTIONS: "Nenhuma interação registrada.",
        NEW_INTERACTION_PLACEHOLDER: "Digite uma nova interação...",
        ADD_INTERACTION_BUTTON: "Adicionar interação",
        STATUS_LABEL: "Status do alerta",
        SAVE_STATUS_BUTTON: "Salvar status",
        INTERACTION_ADDED_SUCCESS: "Interação adicionada com sucesso.",
        INTERACTION_ADD_ERROR: "Não foi possível adicionar a interação.",
        STATUS_UPDATED_SUCCESS: "Status atualizado com sucesso.",
        STATUS_UPDATE_ERROR: "Não foi possível atualizar o status.",
      },
    },
    PROTOCOLS: {
      TITLE: "Protocolos",
      TOTAL_LABEL: "Total",
      ADD_BUTTON: "Adicionar Protocolo",
      DETAILS_BUTTON: "Ver detalhes",
      COLUMNS: {
        PROTOCOL_ID: "Protocolo",
        PLATFORM: "Plataforma",
        CLIENT: "Cliente",
        REGIONAL: "Regional",
        PLATE: "Placa",
        PLATE_ALIAS: "Apelido da Placa",
        TYPE: "Tipo",
        SUBTYPE: "Subtipo",
        STATUS: "Status",
        EVENT_DATE: "Data do Evento",
        REMINDER_DATE: "Lembrete",
        LAST_UPDATE: "Última Atualização",
      },
      FILTERS: {
        START_DATE: "Início",
        END_DATE: "Fim",
        PLATE: "Placa",
        CLIENT: "Cliente",
        PROTOCOL_ID: "Protocolo",
        TYPE: "Tipo",
        SUBTYPE: "Subtipo",
        STATUS: "Status",
        ALL: "Todos",
        SEARCH_BUTTON: "Filtrar",
      },
      MODAL: {
        CREATE_TITLE: "Novo Protocolo",
        DETAILS_TITLE: "Detalhes do Protocolo",
        VEHICLE_LABEL: "Veículo",
        TYPE_LABEL: "Tipo",
        SUBTYPE_LABEL: "Subtipo",
        DESCRIPTION_LABEL: "Descrição",
        EMAIL_LABEL: "E-mail",
        STATUS_LABEL: "Status",
        REMINDER_LABEL: "Lembrete",
        SAVE_BUTTON: "Salvar",
        SAVE_STATUS_BUTTON: "Salvar status",
        SAVE_REMINDER_BUTTON: "Salvar lembrete",
        CREATE_SUCCESS: "Protocolo criado com sucesso.",
        CREATE_ERROR: "Não foi possível criar o protocolo.",
        DETAILS_UPDATED_SUCCESS: "Dados atualizados com sucesso.",
        DETAILS_UPDATE_ERROR: "Não foi possível atualizar os dados.",
        STATUS_UPDATED_SUCCESS: "Status atualizado com sucesso.",
        STATUS_UPDATE_ERROR: "Não foi possível atualizar o status.",
        REMINDER_UPDATED_SUCCESS: "Lembrete atualizado com sucesso.",
        REMINDER_UPDATE_ERROR: "Não foi possível atualizar o lembrete.",
        INTERACTIONS_TITLE: "Interações",
        EMPTY_INTERACTIONS: "Nenhuma interação registrada.",
      },
    },
    PROTOCOL_SUMMARY: {
      TITLE: "Resumo de Protocolos",
      TOTAL_CLIENTS_LABEL: "Total de Clientes",
      TOTAL_PROTOCOLS_LABEL: "Total de Protocolos",
      PROTOCOLS_LINK: "Protocolos",
      FILTERS: {
        REGIONAL: "Regional",
      },
      COLUMNS: {
        CLIENT: "Cliente",
        REGIONAL: "Regional",
        EMAIL: "Login Master",
        QUANTITY: "Quantidade",
        OLDEST_PROTOCOL_DATE: "Protocolo Mais Antigo",
        ADMINISTRATIVE_RESTRICTION: "Restrição Administrativa",
      },
    },
    ERRORS: {
      FETCH_DATA_ERROR: "Erro ao buscar dados",
      FETCH_VEHICLES_STATUS_ERROR: "Erro ao buscar status dos veículos:",
      COMMAND_EXECUTION_ERROR: "Erro ao executar comando",
      FETCH_GROUPS_ERROR: "Erro ao buscar grupos:",
      CONFIG_NOT_FOUND: "Não existe configuração para seu domínio. Envie e-mail para <a href='mailto:contato@mirus.com.br'>contato@mirus.com.br</a>.",
      EMAIL_OR_PASS_INVALID: "Credenciais incorretas. Tente novamente!",
      LOGIN_FAILED: "Não foi possível fazer o login. Verifique os dados utilizados.",
      EMAIL_FORMAT: "O email inserido não é válido",
      CONFIRM_PASS: "As senhas devem ser iguais",
      SEND_RECOVERY_MAILS: "Erro ao enviar senha. Tente novamente mais tarde.",
      USER_NOT_FOUND: "Usuário não encontrado",
      USER_NOT_SELECTED: "Selecione um login.",
      REQUIRED_FIELDS: "Preencha todos os campos",
      RESET_NOT_POSSIBLE: "Erro ao tentar resetar a senha, tente novamente",
      KEY_PASS_INVALID: "Chave não encontrada, clique no link recebido por e-mail",
      SEARCH_ERROR: "Erro na busca.",
      FETCH_DRIVER_LIST_ERROR: "Falha ao buscar lista de motoristas",
      DELETE_DRIVER_ERROR: "Falha ao excluir motorista",
      SAVE_DRIVER_ERROR: "Falha ao salvar dados do motorista",
      SAVE_LINK_ERROR: "Falha ao salvar vínculo do motorista",
      REMOVE_LINK_ERROR: "Falha ao remover vínculo do motorista",
    },
    COMMON: {
      CHART: "Gráfico",
      MIN: "Minimizar",
      MAX: "Maximizar",
      LOADING: "Carregando",
      SEARCH: "Buscar",
      SAVE: "Salvar",
      CLOSE: "Fechar",
      BACK: "Voltar",
      ERROR: "Erro",
      SUCCESS: "Sucesso",
      ATTENTION: "Atenção!!",
      NAME: "Nome",
      DOCUMENT: "Documento",
      PLATE: "Placa",
      CPF_CNPJ: "CPF/CNPJ",
      ID: "ID",
      TYPE: "Tipo",
      DESCRIPTION: "Descrição",
      DATE: "Data",
      NO_DATA_FOUND: "Nenhum dado encontrado",
      YES: "Sim",
      NO:  "Não",
    },
    LOGIN: {
      LOADING_SETTINGS: "Buscando configurações...",
      CONTACTS: "Contatos",
      SOWING_FUTURE: "Semeando Futuro",
      LOGIN: "Login",
      USER: "Usuário",
      PASSWORD: "Senha",
      FORGOT_PASSWORD: "Esqueceu sua senha?",
      ACCESS: "Acessar",
      ACCESSING: "Acessando...",
      SELECT_ACCOUNT: "Selecione uma conta vinculada ao login",
      ACCOUNTS: "Contas",
      BACK: "Voltar",
      NEW_PASSWORD: "Nova Senha",
      CONFIRM_PASSWORD: "Confirmar Senha",
      RESET_PASSWORD: "Redefinir Senha",
      RESETTING: "Redefinindo...",
      RESET: "Redefinir",
      PASSWORD_UPDATED_SUCCESS: "Senha atualizada com sucesso",
      GO_TO_LOGIN_TEXT: "Clique no botão para voltar ao início e logar com a nova senha",
      GO_TO_LOGIN: "Ir para o Login",
      PASSWORD_REMINDER: "Lembrete de senha",
      REMINDER_SENT: "Lembrete de senha enviado para o e-mail {{email}}",
      EMAIL: "Email",
      REMEMBER_PASSWORD: "Lembrar da senha",
      SENDING: "Enviando...",
      LOADING_TEXT: "Carregando...",
    },
    DRIVER: {
      NAME: "Nome",
      DOCUMENT: "Documento",
      FUNCTIONAL_REGISTRY: "Registro funcional",
      RE: "RE",
      IBUTTON_KEY: "Chave iButton",
      LICENSE_NUMBER: "Número CNH",
      LICENSE_CATEGORY: "Categoria CNH",
      CNH: "CNH",
      CNH_CATEGORY: "Categoria CNH",
      LICENSE_EXPIRATION: "Vencimento CNH",
      EXPIRATION: "Vencimento",
      BIRTH_DATE: "Data de nascimento",
      BIRTH: "Nascimento",
      MOBILE_PHONE: "Celular",
      CELL_PHONE: "Celular",
      REGISTER: "Cadastro de Motorista",
      LINKED: "Vinculado",
      PLATE: "PLACA",
      IMPORT_SUCCESS: "Importação realizada com sucesso",
    },
    CLIENT: {
      SEARCH_TITLE: "Pesquisa de clientes",
      FILL_FIELDS_TO_FILTER: "Preencha os campos para filtrar a busca",
      SOCIAL_NAME: "Razão Social",
      TRADE_NAME: "Nome Fantasia",
      PLATE_NICKNAME: "Apelido da Placa",
      CONTRACT_STATUS: "Status do Contrato",
    },
    LOGS: {
      OPERATION_TYPE: "Tipo Operação",
      SEARCH_BUTTON: "Pesquisar",
    },
    BUTTONS: {
      SAVE: "Salvar",
      CLOSE: "Fechar",
      CANCEL: "Cancelar",
      DELETE: "Excluir",
      SEARCH: "Buscar",
      BACK: "Voltar",
      UPDATE: "Atualizar",
    },
    VEHICLE_NICKNAME: {
      TITLE: "Veículo/Apelido",
      EDIT_NICKNAME: "Editar Apelido",
      PLATE: "Placa",
      NICKNAME: "Apelido",
      DELETE: "Excluir",
      CANCEL: "Cancelar",
      NICKNAME_OF_VEHICLE: "o apelido do veículo",
    },
    LINKED_VEHICLES: {
      TITLE: "Veículos Vinculados",
      FILTER_BY_GROUP: "Filtrar por Grupo",
      ALL_GROUPS: "Todos os grupos",
      FILTER_BY_PLATE: "Filtrar por Placa",
      ALL_PLATES: "Todas as placas",
      PLATE: "Placa",
      CURRENT_GROUP: "Grupo Atual",
      SELECT_A_GROUP: "Selecione um grupo",
      CHANGED: "alterado",
      NO_VEHICLES_FOUND: "Nenhum veículo encontrado",
      SAVE_CHANGES: "Salvar alterações",
      CANCEL_CHANGES: "Cancelar alterações",
      NOTHING_TO_SAVE: "Nada para salvar",
      NO_CHANGES_TO_SAVE: "Não há alterações para salvar.",
      NO_RESPONSE: "Sem resposta",
      FAILURES: "Falhas",
    },
    VIEW_MAP_FILTERS: {
      TITLE: "Radar",
      GROUPS: "Grupos",
      ALL_GROUPS: "Todos os grupos",
      VEHICLES: "Veículos",
      ALL_VEHICLES: "Todos os veículos",
      VIEW_VISITS: "Ver visitas",
      OPEN_VISUALIZATION: "Abrir visualização",
      HELP_TEXT: "Selecione os filtros e clique em Abrir visualização para abrir o mapa em tela cheia",
      RECENT_QUERIES:    "Últimas consultas",
      NO_RECENT_QUERIES: "Nenhuma consulta recente encontrada.",
    },
    PROFILE: {
      TITLE: "Perfil",
      USER_PROFILE: "Perfil do usuário",
      PHONE: "Telefone",
      NAME_REQUIRED: "O nome é obrigatório.",
      EMAIL_REQUIRED: "O e-mail é obrigatório.",
      PHONE_REQUIRED: "O telefone é obrigatório.",
      PHONE_INVALID: "Telefone inválido. Formato esperado: (XX) XXXX-XXXX ou (XX) 9XXXX-XXXX.",
      UPDATING: "Atualizando...",
      UPDATED_SUCCESS: "Perfil atualizado com sucesso!",
      UPDATE_ERROR: "Ocorreu um erro ao tentar atualizar o perfil!",
      AVATAR_UPDATED: "Avatar atualizado, será atualizado após realizar login novamente",
    },
    ACCESS_PROFILE: {
      TITLE: "Perfil de Acesso",
      CREATED_PROFILES: "Perfis Criados",
      CREATE_PROFILE: "Criar Perfil",
      CREATE_PROFILE_PLACEHOLDER: "Nome do novo perfil",
      CREATE_BUTTON: "Criar",
      SELECT_PERMISSIONS: "Selecione as permissões para este perfil:",
      SELECT_PROFILE_HINT: "Selecione um perfil acima para configurar as permissões.",
      PROFILE_CREATED_SUCCESS: "Perfil criado com sucesso.",
      PROFILE_CREATE_ERROR: "Não foi possível criar o perfil.",
      PERMISSION_SAVED_SUCCESS: "Permissão atualizada com sucesso.",
      PERMISSION_SAVE_ERROR: "Não foi possível atualizar a permissão.",
      PROFILE_NAME_REQUIRED: "Informe um nome para o novo perfil.",
      LOAD_PERMISSIONS_ERROR: "Não foi possível carregar as permissões deste perfil.",
      CATALOG_NOT_LOADED_HINT: "Abra um perfil existente na lista acima primeiro, para carregar as opções disponíveis.",
      DRAFT_HINT: "Perfil ainda não criado. Marque as permissões desejadas e confirme abaixo.",
      CONFIRM_CREATE_PROFILE: "Criar Perfil com estas Permissões",
      CANCEL_SELECTION: "Cancelar",
    },
    CUSTOMER: {
      TITLE: "Clientes",
      SEARCH_INSTRUCTION: "Faça uma busca pelo CPF/CNPJ ou nome do cliente que deseja consultar ou editar:",
      NEW_CUSTOMER: "Novo Cliente",
      SELECTED_CLIENT_LABEL: "Cliente selecionado: #{{id}} — {{name}}",
      SEARCH_HINT: "Informe um nome ou CPF/CNPJ e clique em Buscar.",
      FILL_SEARCH_HINT: "Informe um nome ou CPF/CNPJ para buscar.",
      SEARCH_ERROR: "Erro ao buscar clientes.",
      COLUMN_NAME: "Nome",
      COLUMN_TRADE_NAME: "Razão Social",
      COLUMN_ACTIVE_CONTRACTS: "Qtd. Contratos Ativos",
      COLUMN_REPRESENTATIVE: "Representante",
      TAB_PERSONAL_DATA: "Dados Pessoais",
      TAB_ADMINISTRATIVE_DATA: "Administrativos",
      TAB_ADDRESS: "Endereço",
      TAB_CONTACTS: "Lista de Contatos",
      TAB_NOTES: "Observações",
      TAB_SETTINGS: "Configurações",
      TAB_COMMERCIAL_CONDITION: "Condição Comercial",
      TAB_LOCKED_TOOLTIP: "Salve o cliente para liberar esta aba.",
      NEW_CUSTOMER_BLOCKED_HINT: "Preencha os dados pessoais e salve para liberar as demais abas.",
      TAB_ASSETS: "Ativos",
      TAB_WIP: "Página ainda em desenvolvimento.",
      NOTES: {
        CLIENT_TITLE: "CADASTRO DE OBSERVAÇÕES DO CLIENTE",
        CLIENT_LABEL: "DESCREVA A OBSERVAÇÃO ABAIXO:",
        CLIENT_PLACEHOLDER: "",
        OPERATIONAL_TITLE: "CADASTRO DE OBSERVAÇÕES OPERACIONAIS",
        OPERATIONAL_PLACEHOLDER: "",
        BILLING_TITLE: "CADASTRO DE OBSERVAÇÕES FATURAMENTO",
        BILLING_PLACEHOLDER: "",
        LOADING: "Carregando observações...",
        LOAD_ERROR: "Não foi possível carregar as observações do cliente.",
        EDIT: "EDITAR",
        SAVE: "SALVAR",
        SAVE_ERROR: "Não foi possível salvar a observação.",
        SAVED_SUCCESS: "Observação salva com sucesso!",
      },
      SETTINGS: {
        SYSTEM_TITLE: "SISTEMA",
        EVENTS_BY_PHONE: "EVENTOS COMUNICADOS PELA CENTRAL POR TELEFONE (CASO NÃO, UM E-MAIL SERÁ ENVIADO)",
        BILLING_TITLE: "COBRANÇA",
        BILLING_EMAIL_ALERT: "ENVIO DE E-MAIL, ALERTA DE VENCIMENTOS E ATRASOS",
        BILLING_SMS_ALERT: "ENVIO DE SMS, ALERTA DE VENCIMENTOS E ATRASOS",
        AUTO_RESTRICTION: "RESTRIÇÃO AUTOMÁTICA POR FALTA DE PAGAMENTO",
        AUTHORIZE_NEGATIVATION: "AUTORIZAR NEGATIVAÇÃO",
        SAVE: "SALVAR",
        LOAD_ERROR: "Não foi possível carregar as configurações do cliente.",
        SAVE_ERROR: "Não foi possível salvar as configurações.",
        SAVED_SUCCESS: "Configurações salvas com sucesso!",
      },
      COMMERCIAL_CONDITION: {
        DUE_DAY: "DIA DE VENCIMENTO",
        NEXT_DUE_DATE: "PRÓXIMO VENCIMENTO",
        CUTOFF_DAY: "DIA DE CORTE",
        PREVIOUS_CYCLE_START: "INÍCIO CICLO ANTERIOR",
        PREVIOUS_CYCLE_END: "FIM CICLO ANTERIOR",
        CURRENT_CYCLE_START: "INÍCIO CICLO ATUAL",
        CURRENT_CYCLE_END: "FIM CICLO ATUAL",
        BILLING_VALIDATED_BY_CLIENT: "VALIDAÇÃO DO FATURAMENTO PELO CLIENTE",
        SELECT: "Selecione",
        SAVE: "SALVAR",
        SELECT_CONDITION_TITLE: "SELECIONE A CONDIÇÃO COMERCIAL",
        TYPE: "TIPO",
        PLAN_VALIDITY: "VIGÊNCIA DO PLANO",
        NEXT_READJUSTMENT: "PRÓXIMO REAJUSTE",
        CONTRACTED_SERVICE_TITLE: "SERVIÇO CONTRATADO",
        SUGGESTED_VALUE: "VALOR SUGERIDO",
        INSTALLMENT_TITLE: "PARCELAS E FORMA DE PAGAMENTO",
        INSTALLMENT_PLAN: "PARCELAS",
        PAYMENT_METHOD: "FORMA DE PAGAMENTO",
        LOAD_CATALOGS_ERROR: "Não foi possível carregar as opções desta tela.",
        LOAD_FEATURES_ERROR: "Não foi possível carregar os serviços contratados.",
        SELECT_A_CONDITION_HINT: "Selecione a Condição Comercial acima para ver os serviços contratados.",
        REGISTERED_CONDITIONS_TITLE: "CONDIÇÕES COMERCIAIS CADASTRADAS",
        NO_CONDITIONS: "Nenhuma condição comercial cadastrada.",
        CONDITION_LABEL: "CONDIÇÃO COMERCIAL",
        PAYMENT_VALUES_TITLE: "VALORES E FORMAS DE PAGAMENTO SERVIÇOS",
        TOTAL_SERVICES: "TOTAL DOS SERVIÇOS",
        TOTAL_PLAN: "TOTAL DO PLANO",
        PERIODICITY: "PERIODICIDADE",
        MONTHLY_FEE: "MENSALIDADE",
        INSTALLATION_VALUE_TITLE: "VALOR DE INSTALAÇÃO",
        EQUIPMENT_VALUE_TITLE: "VALOR DO EQUIPAMENTO",
        VALUE: "VALOR",
        INSTALLMENTS: "PARCELADO EM",
        FINES_TITLE: "VALORES MULTAS E VISITAS IMPRODUTIVAS",
        CONTRACT_TERMINATION_FINE: "MULTA RECISÓRIA",
        TECHNICAL_VISIT: "VISITA TÉCNICA",
        WITHDRAWAL: "RETIRADA",
        UNPRODUCTIVE_VISIT: "VISITA IMPRODUTIVA",
        VEHICLE_EXCHANGE: "TROCA DE VEÍCULO",
        CLEAR: "LIMPAR",
        COLUMN_PLAN: "PLANOS",
        COLUMN_MONTHLY_FEE: "MENSALIDADE",
        COLUMN_CONTRACTS_QTY: "QTD. CONTRATOS",
        EDIT: "EDITAR",
        DEACTIVATE: "DESATIVAR",
        DEACTIVATED_SUCCESS: "Condição comercial desativada com sucesso.",
    },
      CONTACTS_LIST: {
        PAGE_TITLE: "Cadastro de Contatos",
        TRUST_HINT:
          "Os contatos cadastrados têm que ser de confiança, esses contatos são a segunda opção que a Mirus terá para se comunicar.",
        SELECT_PLACEHOLDER: "Selecione",
        PHONE_LABEL: "Telefone",
        EMAIL_LABEL: "E-mail",
        CLEAR: "Limpar",
        NAME_REQUIRED: "Informe o nome do contato.",
        RELATIONSHIP_REQUIRED: "Este campo é obrigatório.",
        PHONE_REQUIRED: "Este campo é obrigatório.",
        EMAIL_REQUIRED: "Este campo é obrigatório.",
        REQUIRED_FIELDS_ERROR: "Preencha corretamente todos os campos.",
        CONTACT_CREATED: "Contato criado com sucesso.",
        CONTACT_UPDATED: "Contato atualizado com sucesso.",
        CONTACT_DELETED: "Contato removido com sucesso.",
        REGISTERED_TITLE: "Contatos Cadastrados",
        LOAD_CONTACTS_ERROR: "Não foi possível carregar os contatos deste cliente.",
        EDIT: "Editar",
        DELETE: "Excluir",
        PHONES_TITLE: "Telefones",
        EMAILS_TITLE: "E-mails",
        ADD_PHONES_TITLE: "Adicionar Telefones",
        ADD_EMAILS_TITLE: "Adicionar E-mails",
        COLUMN_ACTIONS: "Ações",
        COLUMN_NUMBER: "Número",
        REMOVE: "Excluir",
        NO_PHONES: "Nenhum telefone cadastrado.",
        NO_EMAILS: "Nenhum e-mail cadastrado.",
        EXTENSION: "ramal",
        RELATIONSHIP_UNKNOWN: "Vínculo não informado",
        DOC_LABEL: "CPF/CNPJ",
        SAVE_CONTACT_ERROR: "Não foi possível salvar o contato.",
        SAVE_PHONE_ERROR: "Não foi possível salvar o telefone.",
        DELETE_PHONE_ERROR: "Não foi possível excluir o telefone.",
        SAVE_EMAIL_ERROR: "Não foi possível salvar o e-mail.",
        DELETE_EMAIL_ERROR: "Não foi possível excluir o e-mail."},
      PERSONAL_DATA: {
        SECTION_CLIENT_DATA: "Dados do Cliente",
        CLIENT_TYPE: "Tipo de Cliente",
        CLIENT_TYPE_PF: "Pessoa Física",
        CLIENT_TYPE_PJ: "Pessoa Jurídica",
        SIMPLE_TAX: "Simples",
        SECTION_FINANCIAL: "Financeiro",
        CREDIT_ANALYSIS: "Análise de Crédito",
        CREDIT_ANALYSIS_APPROVED: "Aprovado",
        CREDIT_ANALYSIS_REJECTED: "Reprovado",
        DDA: "DDA",
        INSTALLMENT_BOOKLET: "Carnê",
        SECTION_RESTRICTION: "Restrição Administrativa",
        RESTRICTION_TYPE: "Tipo de Restrição",
        SECTION_COMMERCIAL: "Responsável Comercial",
        REPRESENTATIVE: "Representante",
        COMMERCIAL: "Comercial",
        SECTION_SERVICE_PLAN: "Plano de Serviço",
        SERVICE_PLAN: "Plano de Serviço",
        CLIENT_ID: "ID Cliente",
        DOC: "CPF/CNPJ",
        CLIENT_NAME: "Razão Social",
        CLIENT_TRADE_NAME: "Nome Fantasia",
        STATE_REGISTRATION: "Inscrição Estadual",
        MUNICIPAL_REGISTRATION: "Inscrição Municipal",
        BIRTH_DATE: "Data Nasc./Const.",
        EMAIL: "E-mail",
        PHONE: "Telefone",
        CELLPHONE: "Celular",
        CREATED_AT: "Data Cadastro",
        UPDATED_AT: "Última Alteração",
        RESTRICTION_START_DATE: "Data Início",
        RESTRICTION_END_DATE: "Data Fim",
        LAST_SUSPENSION_DATE: "Última Suspensão",
        SELECT_PLACEHOLDER: "Selecione",
        SOURCE_TBD: "Fonte de dados a definir.",
        LOAD_PLANS_ERROR: "Não foi possível carregar os planos de serviço.",
        LOAD_CLIENT_ERROR: "Não foi possível carregar os dados do cliente.",
        LOAD_RESTRICTIONS_ERROR: "Não foi possível carregar os tipos de restrição.",
        LOAD_REPRESENTATIVES_ERROR: "Não foi possível carregar os representantes.",
        LOAD_SALESPEOPLE_ERROR: "Não foi possível carregar os comerciais.",
        BILLING_BUTTON: "Cobrança",
        REQUIRED_FIELDS_ERROR: "Preencha os campos obrigatórios (Nome e CPF/CNPJ) antes de salvar.",
        CLIENT_NAME_REQUIRED: "Nome é obrigatório.",
        DOC_REQUIRED: "CPF/CNPJ é obrigatório.",
        REPRESENTATIVE_REQUIRED: "Representante é obrigatório.",
        SERVICE_PLAN_REQUIRED: "Plano de Serviço é obrigatório.",
        SALESPERSON_REQUIRED: "Comercial é obrigatório.",
        REQUIRED_FIELDS_HINT: "Campos obrigatórios",
        UPDATING: "Salvando...",
        UPDATED_SUCCESS: "Cliente salvo com sucesso!",
        UPDATE_ERROR: "Ocorreu um erro ao salvar o cliente!",
      },
      ASSETS: {
        PAYER_HINT: "* Para que possa alterar a condição comercial, selecione o cliente pagante.",
        SEARCH_PAYER_TITLE: "Buscar Cliente Pagante",
        CLEAR: "Limpar",
        STATUS_LABEL: "Selecione o Status",
        SELECT_PLACEHOLDER: "Selecione",
        TOTAL_CONTRACTS: "Total de Contratos",
        SEARCH_CONTRACTS: "Buscar Contratos",
        RESULTS_TITLE: "Contratos do Cliente Selecionado",
        SEARCH_HINT: "Informe os filtros e clique em Buscar Contratos.",
        COLUMN_CONTRACT: "Contrato",
        COLUMN_PLATE: "Placa",
        COLUMN_REGISTERED_AT: "Data Base",
        COLUMN_ACTIVATED_AT: "Data Ativação",
        COLUMN_LAST_CHANGE_AT: "Última Alteração",
        COLUMN_STATUS: "Status",
        COLUMN_PAYER_NAME: "Cliente Pagante",
        COLUMN_COMMERCIAL_CONDITION: "Condição Comercial",
        COLUMN_ACTIONS: "Ações",
        DETAILS_BUTTON: "Detalhes",
        DETAILS_TITLE: "Detalhes do Contrato",
        DETAILS_WIP: "Tela de detalhes do contrato {{contractId}} ainda não implementada."
      },
      ADDRESS: {
        MAIN_TITLE: "CADASTRO DO ENDEREÇO PRINCIPAL",
        BILLING_TITLE: "CADASTRO DO ENDEREÇO DE COBRANÇA",
        SAME_AS_MAIN: "Mesmo que o endereço principal.",
        CEP: "CEP",
        STREET: "ENDEREÇO",
        NUMBER: "NÚMERO",
        NEIGHBORHOOD: "BAIRRO",
        COMPLEMENT: "COMPLEMENTO",
        UF: "UF",
        CITY: "CIDADE",
        INVALID_CEP: "Informe um CEP válido.",
        CEP_NOT_FOUND: "CEP não encontrado.",
        CEP_SEARCH_ERROR: "Erro ao buscar o CEP.",
        CEP_FOUND: "CEP encontrado.",
        LOAD_ERROR: "Não foi possível carregar o endereço do cliente.",
        SAVING: "Salvando...",
        SAVE_ERROR: "Não foi possível salvar o endereço.",
        SAVED_SUCCESS: "Endereço salvo com sucesso!",
      },
    },
    DRIVER_PROFILE: {
      VEHICLES: "Veículos",
    },
    LOGS_CONTROL: {
      ID: "Id",
      TYPE: "Tipo",
      DESCRIPTION: "Descrição",
      DATE: "Data",
    },
    GROUP_USERS: {
      TITLE: "Vincular usuários aos grupos",
      GROUPS: "Grupos",
      SELECT_ALL: "Selecionar Todos",
      REMOVE_ALL: "Remover Todos",
      USER: "Usuario",
      EMAIL: "Email",
      BIND: "Vincular",
      SAVE: "Salvar",
      SAVING: "Salvando...",
      LOADING_USERS: "Carregando usuários do grupo...",
      PROCESSING: "Processando...",
      SELECT_GROUP_MESSAGE: "Selecione um grupo para visualizar os usuários.",
      NO_USERS_FOUND: "Nenhum usuário encontrado neste grupo.",
      NO_MARKER_SELECTED: "Nenhum marcador selecionado.",
      NO_GROUP_SELECTED: "Nenhum grupo selecionado.",
      CHANGES_SAVED: "alteração(ões) salva(s) com sucesso.",
      SAVE_ERROR: "Não foi possível salvar as alterações.",
      REQUEST_ERROR: "Falha na requisição.",
    },
    TRANSPORT_CLIENTS: {
      PAGE_TITLE: "Clientes",
      LIST_TITLE: "Empresas cadastradas",
      ADD_NEW: "Adicionar",
      EDIT_TITLE: "Editar Empresa",
      NEW_TITLE: "Nova Empresa",
      COMPANY_NAME: "Nome da Empresa",
      CNPJ: "CNPJ",
      PHONE_1: "Tel. Principal",
      PHONE_2: "Tel. Secundário",
      EMAIL: "E-mail",
      SEND_NON_CONFORMITY_EMAIL: "Enviar relatório de não conformidade quando a linha for concluída.",
      SEND_CONFORMITY_EMAIL: "Incluir as conformidades no relatório enviado.",
      SEND_COPY: "Ser copiado no relatório enviado ao cliente.",
      SAVE: "Salvar",
      CANCEL: "Cancelar",
      ACTIONS: "Ações",
      EDIT: "Editar",
      DELETE: "Excluir",
      COMPANY_NAME_REQUIRED: "Nome da empresa é obrigatório.",
      CNPJ_REQUIRED: "CNPJ é obrigatório.",
      CNPJ_INVALID: "CNPJ inválido.",
      EMAIL_REQUIRED: "E-mail é obrigatório.",
      EMAIL_INVALID: "E-mail inválido.",
      LOGIN: "Login",
      LAST_ACCESS: "Último Acesso",
      NO_RECORDS_FOUND: "Nenhum registro encontrado",
      LOAD_ERROR: "Erro ao carregar empresas",
      SAVE_ERROR: "Ocorreu um erro ao salvar a empresa.",
      SAVE_SUCCESS_NEW: "Empresa cadastrada com sucesso!",
      SAVE_SUCCESS_EDIT: "Empresa atualizada com sucesso!",
      DELETE_SUCCESS: "Empresa excluída com sucesso!",
      DELETE_ERROR: "Ocorreu um erro ao excluir a empresa.",
      LAST_ACCESS_DATE: "Última data de acesso",
    },
    TRANSPORT_PATHS: {
      PAGE_TITLE: "Linhas",
      LIST_TITLE: "Linhas cadastradas",
      ADD_NEW: "Adicionar",
      EDIT_TITLE: "Editar Linha",
      NEW_TITLE: "Nova Linha",
      COMPANY: "Nome da Empresa",
      SELECT_COMPANY: "Selecione uma empresa",
      SELECT_COMPANY_MESSAGE: "Selecione uma empresa para visualizar as linhas.",
      NAME: "Nome da Linha",
      PURPOSE: "Finalidade",
      SELECT_PURPOSE: "Selecione",
      PURPOSE_ENTRY: "Entrada",
      PURPOSE_EXIT: "Saída",
      DAYS: "Selecione os dias de operação da linha",
      SUNDAY: "Domingo",
      MONDAY: "Segunda",
      TUESDAY: "Terça",
      WEDNESDAY: "Quarta",
      THURSDAY: "Quinta",
      FRIDAY: "Sexta",
      SATURDAY: "Sábado",
      START_TIME: "Horário Inicial",
      END_TIME: "Horário Final",
      GROUP: "Grupo",
      ALL_GROUPS: "Todos",
      VEHICLE: "Veículo",
      SELECT_VEHICLE: "Selecione",
      SAVE: "Salvar",
      CANCEL: "Cancelar",
      CLEAR: "Limpar",
      ACTIONS: "Ações",
      EDIT: "Editar",
      DELETE: "Excluir",
      LINE_COLUMN: "Linha",
      START_COLUMN: "Início",
      END_COLUMN: "Fim",
      WEEK_COLUMN: "Semana",
      VEHICLE_COLUMN: "Veículo",
      NAME_REQUIRED: "Nome da linha é obrigatório.",
      PURPOSE_REQUIRED: "Finalidade é obrigatória.",
      VEHICLE_REQUIRED: "Veículo é obrigatório.",
      NO_RECORDS_FOUND: "Nenhuma linha encontrada",
      LOAD_ERROR: "Erro ao carregar linhas",
      SAVE_ERROR: "Ocorreu um erro ao salvar a linha.",
      SAVE_SUCCESS_NEW: "Linha cadastrada com sucesso!",
      SAVE_SUCCESS_EDIT: "Linha atualizada com sucesso!",
      DELETE_SUCCESS: "Linha excluída com sucesso!",
      DELETE_ERROR: "Ocorreu um erro ao excluir a linha.",
      REPROCESS_DAILY: "Reprocessar Diários",
      REPROCESS_SUMMARY: "Reprocessar Resumo",
      START_DATE: "Data Inicial",
      END_DATE: "Data Final",
      EXPORT_FILE: "Exportar Arquivo",
      FEATURE_NOT_AVAILABLE: "Funcionalidade ainda não disponível.",
    },
    NOTIFICATIONS_CONFIG: {
      PAGE_TITLE: "Notificações",
      LIST_TITLE: "Configuração de Notificações",
      SELECT_ALL: "Selecionar Todos",
      DESELECT_ALL: "Desmarcar Todos",
      NO_RECORDS_FOUND: "Nenhuma notificação encontrada",
      LOAD_ERROR: "Erro ao carregar notificações",
      SAVE_ERROR: "Ocorreu um erro ao atualizar a notificação.",
      SAVE_SUCCESS: "Notificação atualizada com sucesso!",
    },
    GROUPS: {
      PAGE_TITLE: "Cadastro de Grupos",
      LIST_TITLE: "Lista de Grupos",
      REGISTER_TITLE: "Dados do Grupo",
      DELETE_ERROR_TITLE: "Erro ao excluir",
      DELETE_ERROR_TEXT: "Grupo em uso, exclusão não permitida.",
      FILTERS: "Filtros",
      SELECT_GROUP: "Selecione um grupo",
      CURRENT_GROUP: "Grupo Atual",
      NO_VEHICLES_FOUND: "Nenhum veículo encontrado",
      ACTION_CONFIRMED: "Ação confirmada!",
      CONFIRM: "Confirmar",
      DESCRIPTION: "Descrição",
      DEFAULT: "Padrão",
      DEFINE_DEFAULT: "Definir Padrão",
      DELETE: "Excluir",
      SELECT_GROUP_REQUIRED: "Selecione um grupo de destino para mover os veículos antes de excluir.",
      MOVE_VEHICLES_ERROR: "Não foi possível mover os veículos para o novo grupo. A exclusão foi cancelada.",
    },
    MODAL_VISITS: {
      TITLE: "Veículos Próximos",
      GRID: "Grade",
      MAP: "Mapa",
      PLATE: "Placa",
      MODEL: "Modelo",
      DISTANCE: "Distância (m)",
      LAST_POSITION: "Última Posição",
      EXPORT_PDF: "Exportar PDF",
      EXPORT_EXCEL: "Exportar Excel",
      NO_VEHICLES_NEARBY: "Nenhum veículo próximo encontrado",
    },
    VISIT_CONTROL: {
      TITLE: "Controle de Visitas",
      NEW_VISIT: "Nova Visita",
      EDIT_VISIT: "Editar Visita",
      VISIT_NAME: "Nome da Visita",
      ADDRESS: "Endereço",
      RADIUS: "Raio (m)",
      CATEGORY: "Categoria",
      SAVE_SUCCESS: "Visita salva com sucesso",
      DELETE_SUCCESS: "Visita excluída com sucesso",
    },
    VISIT_POINTS: {
      TITLE: "Pontos de Visita",
      POINT_NAME: "Nome do Ponto",
      COORDINATES: "Coordenadas",
      CREATED_AT: "Criado Em",
      VIEW_MARKER: "Visualizar marcador",
      EDIT_MARKER: "Editar marcador",
      CREATE_MARKER: "Criar marcador por:",
      ADDRESS: "Endereço",
      COORDINATE: "Coordenada",
      NAME: "Nome",
      RADIUS: "Raio (m)",
      RADIUS_SELECT: "-- Raio --",
      ADDRESS_PLACEHOLDER: "Digite o endereço...",
      LATITUDE: "Latitude",
      LONGITUDE: "Longitude",
      EDIT: "Editar",
      DISPLAY: "Exibir",
      INSERT: "Inserir",
      UPDATE: "Atualizar",
      MARKER_PLACEHOLDER: "Marcador",
      SELECT_ADDRESS: "Selecione um endereço",
      EDIT_COORDINATE: "Editar Coordenada",
      PROCESSING: "Processando...",
      CANCEL: "Cancelar",
      SAVE: "Salvar",
      SAVING: "Salvando...",
      CONFIRM_DELETE: "Confirmar exclusão",
      DELETE_MESSAGE: "Deseja realmente excluir o endereço",
      DELETE: "Excluir",
      VISIT_POINTS: "Ponto de visitas",
      MAP: "Map",
      MAP_HEADER: "Mapa",
    },
    REGISTER_VEHICLE: {
      TITLE: "Cadastro de Veículos",
      VEHICLE_DATA: "Dados do Veículo",
      LICENSE_PLATE: "Placa",
      CHASSIS: "Chassi",
      MODEL: "Modelo",
      YEAR: "Ano",
      COLOR: "Cor",
      SAVE_SUCCESS: "Veículo salvo com sucesso",
    },
    CONTROL_POINTS: {
      TITLE: "Pontos de Controle",
      NEW_POINT: "Novo Ponto",
      POINT_NAME: "Nome do Ponto",
      DESCRIPTION: "Descrição",
      TYPE: "Tipo",
    },
    VEHICLES_CONFIG: {
      TITLE: "Configurações de Veículos",
      GENERAL: "Geral",
      NOTIFICATIONS: "Notificações",
      SPEED_LIMIT: "Limite de Velocidade",
      FUEL: "Combustível",
      MAINTENANCE: "Manutenção",
    },
    RISK_AREA: {
      TITLE: "Áreas de Risco",
      NEW_AREA: "Nova Área",
      AREA_NAME: "Nome da Área",
      DANGER_LEVEL: "Nível de Perigo",
      LOW: "Baixo",
      MEDIUM: "Médio",
      HIGH: "Alto",
      CRITICAL: "Crítico",
      GRID: "Grade",
      MAP: "Mapa",
      DESCRIPTION: "Descrição",
      LOCATION: "Localização",
      ACTIONS: "Ações",
      EDIT: "Editar",
      DELETE: "Excluir",
      VIEW: "Visualizar",
      SEARCH_ADDRESS: "Buscar endereço",
      DRAW_POLYGON: "Desenhar polígono",
      EDIT_MODE: "Edição ligada",
      SAVE_AREA: "Salvar Área",
      UPDATE_AREA: "Atualizar Área",
      CLEAR: "Limpar",
      SAVE: "Salvar",
      SAVING: "Salvando...",
      CANCEL: "Cancelar",
      CLOSE: "Fechar",
      CONFIRM_DELETE: "Confirmar exclusão",
      DELETE_MESSAGE: "Deseja realmente excluir a área",
      AREA_DESCRIPTION: "Descrição da área",
      POLYGON_DESCRIPTION: "Descrição do polígono",
      BIND_VEHICLES: "Vincular Veículos",
      RISK_AREAS: "Areas de risco",
      POLYGON_FENCES: "Cercas Poligonais",
      ADDRESS_PLACEHOLDER: "Digite cidade, bairro ou endereço…",
      SEARCH: "Buscar",
    },
    ELETRONIC_FENCES: {
      TITLE: "Cercas Eletrônicas",
      NEW_FENCE: "Nova Cerca",
      CREATE_FENCE: "Criar cerca",
      EDIT_FENCE: "Editar cerca",
      FENCE_NAME: "Nome da Cerca",
      FENCE_TYPE: "Tipo de Cerca",
      CIRCULAR: "Circular",
      POLYGONAL: "Poligonal",
      ACTIVE: "Ativa",
      INACTIVE: "Inativa",
      ALERT_ON_ENTRY: "Alerta ao Entrar",
      ALERT_ON_EXIT: "Alerta ao Sair",
      GRID: "Grade",
      MAP: "Mapa",
      DESCRIPTION: "Descrição",
      LOCATION: "Localização",
      RADIUS: "Raio (m)",
      ACTIONS: "Ações",
      EDIT: "Editar",
      DELETE: "Excluir",
      VIEW: "Visualizar Cerca",
      ORIGIN: "Origem",
      DESTINATION: "Destino",
      BUFFER_WIDTH: "Largura da cerca (m)",
      CALCULATE_ROUTE: "Calcular rota",
      APPLY_BUFFER: "Aplicar",
      SAVE: "Salvar",
      SAVING: "Salvando...",
      CANCEL: "Cancelar",
      CLOSE: "Fechar",
      CONFIRM_DELETE: "Confirmar exclusão",
      DELETE_MESSAGE: "Deseja realmente excluir a cerca",
      // eslint-disable-next-line no-dupe-keys
      EDIT_FENCE: "Editar Cerca",
      VIEW_FENCE: "Visualizar Cerca",
      // eslint-disable-next-line no-dupe-keys
      CREATE_FENCE: "Criar Cerca Eletrônica",
      BIND_VEHICLES: "Vincular Veículos",
      BIND_GROUPS: "Vincular Grupos",
      VEHICLE_GROUPS: "Grupos de Veículos",
      SELECT_GROUP: "Selecione um grupo",
      VEHICLES: "Veículos",
      SELECT_VEHICLES: "Selecione os veículos",
      SAVE_BINDINGS: "Salvar Vínculos",
      ORIGIN_FENCE: "Origem da cerca",
      DESTINATION_FENCE: "Destino da cerca",
      ORIGIN_FENCE_EDITED: "Origem da cerca editada",
      DESTINATION_FENCE_EDITED: "Destino da cerca editada",
      ERROR_ROUTE_DRAW: "Erro ao traçar rota",
      ERROR_LOAD_FENCE_DATA: "Erro ao carregar dados da cerca. Tente novamente.",
      FENCE_DELETED_SUCCESS: "Cerca excluída com sucesso.",
      FENCE_DELETE_FAIL: "Não foi possível excluir a cerca.",
      UNEXPECTED_DELETE_FAILURE: "Falha inesperada ao excluir.",
      REVERSE_GEOCODING_ERROR: "Erro na geocodificação reversa",
      PLEASE_ENTER_FENCE_DESCRIPTION: "Por favor, informe uma descrição para a cerca eletrônica",
      INVALID_POLYGON_TITLE: "Polígono inválido",
      INVALID_POLYGON_MIN_POINTS: "O polígono deve ter pelo menos 3 pontos",
      SAVED_SUCCESS: "Salvo com sucesso",
      ERROR_UPDATE_FENCE: "Erro ao atualizar cerca eletrônica. Tente novamente.",
      INCOMPLETE_POINTS_TITLE: "Pontos incompletos",
      DEFINE_ORIGIN_DESTINATION_BEFORE_SAVE: "Defina origem e destino antes de salvar",
      ROUTE_NOT_CALCULATED_TITLE: "Rota não calculada",
      CALCULATE_ROUTE_BEFORE_SAVE: "Calcule a rota antes de salvar",
      ERROR_SAVE_FENCE: "Erro ao salvar cerca eletrônica. Tente novamente.",
      GENERATED_BY_MAP: "Cerca eletrônica gerada pelo mapa",
      FENCE_UPDATED_TITLE: "Cerca Atualizada",
      FENCE_UPDATED_SUCCESS: "Cerca eletrônica atualizada com sucesso",
      ERROR_UPDATE_FENCE_SHORT: "Erro ao atualizar cerca eletrônica",
      ERROR_LOADING_FENCES: "Erro ao carregar as cercas. Tente novamente.",
      FENCE_NOT_FOUND: "Cerca não encontrada",
      ERROR_LOADING_EDIT_DATA: "Erro ao carregar dados para edição",
      DELETE_WITHOUT_LINKED_VEHICLE_MSG: "Para que você possa excluir uma cerca ele não pode ter nenhum veículo vinculado",
      NO_VEHICLES_FOUND_FOR_POINT: "Nenhum veículo encontrado para este ponto.",
      AREA_DESCRIPTION_PLACEHOLDER: "Ex: Área de risco - Zona Norte",
      EDITING: "Editando",
      CLICK_MAP_DEFINE: "Definir por clique no mapa:",
      ORIGIN_INPUT_LABEL: "Origem (digite/seleciona ou clique no mapa)",
      DESTINATION_INPUT_LABEL: "Destino (digite/seleciona ou clique no mapa)",
      ORIGIN_PLACEHOLDER: "Av. Paulista, 1000, São Paulo…",
      DESTINATION_PLACEHOLDER: "Praça da Sé, São Paulo…",
      SWAP: "Inverter",
      CLEAR: "Limpar",
      ORIGINAL_ROUTE: "Rota original",
      ELECTRONIC_FENCE: "Cerca Eletrônica",
      ERROR_CALCULATE_ROUTE: "Erro ao calcular rota. Verifique se os pontos de origem e destino estão definidos.",
      LOADING_FENCES: "Carregando cercas eletrônicas...",
      BIND_UNBIND: "Vincular / Desvincular",
      VIEW_ON_MAP: "Visualizar no mapa",
    },
    ROUTING: {
      TITLE: "Roteirização",
      VIEW_MAP: "Visualizar mapa",
      COPY_LINK: "Copiar link",
      GENERATE_FENCE: "Gerar cerca eletrônica",
      ADD_POINT: "Adicionar ponto",
      TYPE_ADDRESS: "Endereço",
      TYPE_COORDINATE: "Coordenada",
      TYPE_VISIT_POINT: "Ponto de visita",
      LATITUDE: "Latitude",
      LONGITUDE: "Longitude",
      LOADING_VISIT_POINTS: "Carregando pontos de visita...",
      SELECT_VISIT_POINT: "Selecione um ponto de visita",
      ERROR_CALCULATE_ROUTE: "Erro ao calcular a rota. Verifique se os pontos de origem e destino estão definidos.",
      LINK_COPIED: "Link copiado para a área de transferência",
      LINK_COPY_ERROR: "Erro ao copiar o link",
      MAX_POINTS_REACHED: "Número máximo de pontos atingido (25)",
    },
    VEHICLE_NEAREST: {
      TITLE: "Veículo mais próximo",
      SELECT_METHOD: "Selecione a forma que deseja colocar o veículo mais próximo",
      ADDRESS: "Endereço",
      VEHICLE: "Veículo",
      VISIT_POINT: "Ponto de Visita",
      ENTER_ADDRESS: "Digite endereço que deseja",
      LOCATE_ADDRESS: "Localizar endereço",
      NO_ADDRESS_FOUND: "Nenhuma informação encontrada para o endereço informado",
      SELECT_VEHICLE_DISTANCE: "Selecione o veículo que deseja calcular a distância de ponto",
      GROUPS: "Grupos",
      ALL_GROUPS: "Todos os grupos",
      VEHICLES: "Veículos",
      ALL_VEHICLES: "Todos os veículos",
      FILTER: "Filtrar",
      GROUP: "Grupo",
      DATE_TIME: "Data/Hora",
      NO_VEHICLE_INFO: "Nenhuma informação encontrada para os veículos do usuário",
      SELECT_POINT: "Selecione o ponto que deseja localizar o veículo mais próximo",
      SEARCH_RADIUS: "Raio de Busca",
      FOUND_VEHICLES: "Veículos Encontrados",
      NO_VEHICLES: "Nenhum veículo encontrado na área",
    },
    FILTERS_COMPONENT: {
      MINIMUM_DURATION: "Duração Mínima",
      TYPE: "Tipo",
      BOTH: "Ambos",
      VISIT_POINT: "Ponto de Visita",
      STOP_POINT: "Ponto de Parada",
      ALL: "Todos",
      COMPANY_SPEED_ONLY: "Somente velocidade da empresa",
      ROAD_SPEED_MODERATE: "Acima da velocidade da via - infração média",
      ROAD_SPEED_SERIOUS: "Acima da velocidade da via - infração grave",
      ROAD_SPEED_VERY_SERIOUS: "Acima da velocidade da via - infração gravíssima",
      ROAD_SPEED_ALL: "Acima da velocidade da via - infração (todos)",
      VEHICLE: "Veículo",
      ALL_VEHICLES: "Todos os veículos",
      DRIVERS: "Motoristas",
      ALL_DRIVERS: "Todos os motoristas",
      START: "Início",
      END: "Fim",
      START_DATE_TIME: "Data e hora início",
      END_DATE_TIME: "Data e hora fim",
      REPORTS: "Relatórios",
      DISPLAY: "Exibir",
      EXCEL: "Excel",
      PDF: "PDF",
    },
    CLIENT_DETAILS: {
      PAGE_TITLE: "Detalhe de cliente",
      VIEW_CLIENT: "Visualizar Cliente",
      FANTASY_NAME: "Nome Fantasia",
      SHORT_NAME: "Nome Abreviado",
      FULL_NAME: "Nome Completo",
      SOCIAL_NAME: "Razão Social",
      IDENTIFICATION: "Identificação",
      ADDRESS: "Endereço",
      ADDRESS_2: "Endereço 2",
      COMPANY_REGISTRATION: "Registro da empresa",
      PHONE_1: "Telefone 1",
      PHONE_2: "Telefone 2",
      OBSERVATION: "Observação",
      NUMBER: "Número",
      NEIGHBORHOOD: "Bairro",
      COMPLEMENT: "Complemento",
      STATE: "Estado",
      CITY: "Cidade",
      ZIP_CODE: "CEP",
      CNPJ: "CNPJ",
      STATE_REGISTRATION: "Inscrição Estadual",
      MUNICIPAL_REGISTRATION: "Inscrição municipal",
      SIMPLE_TAX_OPTANT: "Optante pelo Simples Nacional",
      PUBLIC_COMPANY: "Empresa Pública",
      YES: "Sim",
      NO: "Não",
      PERSON_TYPE: "Tipo de Pessoa",
      INDIVIDUAL: "Pessoa Física",
      COMPANY: "Pessoa Jurídica",
    },
    TABLE: {
      DEFAULT: "Padrão",
      ACTIONS: "Ações",
      FILTER: "Filtrar",
      GLOBAL_SEARCH: "Pesquisa global",
      LOAD_DATA_ERROR: "Erro ao carregar os dados",
      SELECT_OPTION: "Selecione uma opção para exibir os dados.",
    },
    USER_NAV: {
      USER_PROFILE: "Perfil do Usuário",
      CHANGE_PASSWORD: "Alterar Senha",
      CLIENT_USERS: "Usuários do cliente",
      COMPANY: "Empresa",
      NOTIFICATIONS: "Notificações",
      FILL_BOTH_FIELDS: "Preencha os dois campos",
      PASSWORDS_MUST_MATCH: "As duas senhas devem ser iguais",
      PASSWORD_CHANGED: "Senha alterada",
      PASSWORD_CHANGED_SUCCESS: "Senha alterada com sucesso",
      PASSWORD_CHANGE_ERROR: "Erro ao alterar a senha, tente novamente mais tarde",
    },
    DELETE_MODAL: {
      CONFIRM_DELETE: "Deseja realmente excluir?",
      OK: "Ok",
    },
    MESSAGE_MODAL: {
      WARNING: "Aviso!",
    },
    VEHICLE_DRAWER: {
      TITLE: "Informações do veículo",
      INFO: "Informações",
      TRAIL: "Rastro",
      TRAIL_SOON: "Rastro (em breve)",
      COMMANDS: "Comandos",
      COMMANDS_SOON: "Comandos (em breve)",
      STREET_VIEW_UNAVAILABLE: "Street View indisponível nesta localização",
    },
    INFO_WINDOW: {
      VEHICLE: "Veículo",
      MODEL: "Modelo",
      MANUFACTURER: "Montadora",
      YEAR: "Ano",
      CATEGORY: "Categoria",
      ADDRESS: "Endereço",
      STATUS: "Status",
      EVENT: "Evento",
      DRIVER: "Motorista",
      IGNITION_BATTERY: "Ignição (Bateria)",
      GROUP: "Grupo",
      SPEED: "Velocidade",
      ODOMETER: "Odômetro",
      TIME_ELAPSED: "Quanto Tempo",
      TRACKER_BATTERY: "Bateria do Rastreador",
      VEHICLE_BATTERY: "Bateria do Veículo",
    },
    MAINTENANCES: {
      MAINTENANCE_ITEM: {
        DESCRIPTION: "Adicione o item que deseja ter controle de uso",
        INPUT_PLACEHOLDER: "Digite o nome do item",
        BTN_SAVE: "Salvar Novo",
        BTN_CANCEL: "Cancelar",
        FIELD_TABLE_ITEM: "Item",
        FIELD_TABLE_EDIT: "Editar",
        FIELD_TABLE_DELETE: "Excluir",
      },
      SCHEDULING: {
        DESCRIPTION: "Configure o item que deseja ter o controle de uso",
        ITEMS: "Itens",
        SELECT_ITEM: "Selecione um item",
        SCHEDULING: "Agendamento",
        SINGLE_ENTRY: "Lançamento avulso",
        DATE: "Data",
        KM: "Km",
        OR: "Ou",
        SELECT: "Selecione",
        DAYS: "dias",
        MAINTENANCE_COST: "Custo da manutenção",
        UPDATE: "Atualizar",
        SAVE: "Salvar",
        SAVING: "Salvando...",
        CLEAR: "Limpar",
        VEHICLE: "Veículo",
        ITEM: "Item",
        TIME_DAYS: "Tempo (dias)",
        ADDED: "Adicionado",
        ACTIONS: "Ações",
        NO_ITEMS_SCHEDULED: "Não há itens agendados para este veículo",
      },
      COMPLETED: {
        TITLE: "Manutenções Realizadas",
        DESCRIPTION: "Selecione o veículo e digite o período",
        UNTIL: "Até",
        SEARCH: "Buscar",
      },
      PENDINGS: {
        TITLE: "Manutenções Pendentes",
        DESCRIPTION: "Selecione o veículo e digite o período",
        STATUS: "Status",
        SELECT_STATUS: "Selecione o status",
        STATUS_SELECT: "Selecione",
        STATUS_UP_TO_DATE: "Em dia",
        STATUS_PROVIDE: "Providenciar",
        STATUS_DELAYED: "Atrasado",
        STATUS_COMPLETED: "Concluído",
        SEARCH: "Buscar",
      },
      REGISTER_KM: {
        TITLE: "Registro de Odometro",
        DESCRIPTION: "Para efetuar o cadastro de KM, selecione o veículo e preencha as informações",
        REGISTER: "Registrar",
        SEARCH_FILTER: "Busca / Filtro",
        SEARCH: "Buscar",
      },
      SHIPPING: {
        TITLE: "Acompanhamento de itens",
        DESCRIPTION: "Visualize todos os itens cadastrados, você pode filtrar por veículo, item e/ou status",
        ITEMS: "Itens",
        SELECT_ITEM: "Selecione um item",
        STATUS: "Status",
        SELECT_STATUS: "Selecione o status",
        SEARCH: "Buscar",
        VEHICLE_ITEMS: "Itens de veículos",
        VEHICLE: "Veículo",
        ITEM: "Item",
        HOURS: "Horas",
        EDIT: "Editar",
        DELETE: "Excluir",
        CONFIRM_DELETE: "Confirmar exclusão",
        CONFIRM_DELETE_MESSAGE: "Tem certeza que deseja deletar este item?",
        CANCEL: "Cancelar",
      }
    },
    PREVIEWS: {
      CREATE_LICENSED: {
        PAGE_TITLE: "Criar Licenciado",
        PAGE_SUBTITLE: "Configure identidade visual e parâmetros",
        SAVE: "Salvar",
        SAVING: "Salvando...",
        SAVED: "Salvo!",
        TABS: {
          LICENSEE: "Licenciado",
          IMAGES: "Imagens",
          GENERAL_COLORS: "Cores Gerais",
          MENU: "Menu",
          CARDS: "Cards",
          FILTERS: "Filtros",
          TABLES: "Tabelas",
          BUTTONS: "Botões",
        },
        THEME: {
          LIGHT: "Light",
          DARK: "Dark",
        },
        LICENSEE: {
          SECTION_TITLE: "Dados do Licenciado",
          LICENSED_ID_LABEL: "ID do Licenciado",
          LICENSED_ID_PLACEHOLDER: "Ex: 4939",
          PLATFORM_NAME_LABEL: "Nome da Plataforma",
          PLATFORM_NAME_PLACEHOLDER: "Ex: Olhar Fixo v3",
          PHRASE_LABEL: "Frase / Slogan",
          PHRASE_PLACEHOLDER: "Ex: Ajudando sua empresa crescer",
          DOMAIN_LABEL: "Domínio",
          PHONE_LABEL: "Telefone",
          CENTRAL_PHONE_LABEL: "Telefone da Central",
          IOS_LINK_LABEL: "Link iOS App Store",
          ANDROID_LINK_LABEL: "Link Android Play Store",
          LANGUAGE_LABEL: "Idioma",
          LANG_PT_BR: "Português (BR)",
          LANG_EN_US: "English (US)",
          LANG_ES: "Español",
        },
        IMAGES: {
          SECTION_TITLE: "Imagens do Sistema",
          COMPANY_LOGO_LABEL: "Logo da Empresa",
          COMPANY_LOGO_DESC: "Exibida no login e navbar",
          HOME_SCREEN_LABEL: "Imagem da Tela Inicial",
          HOME_SCREEN_DESC: "Imagem outdoor na tela de login",
          CONDENSED_MENU_LABEL: "Menu Condensado",
          CONDENSED_MENU_DESC: "Ícone para menu colapsado",
          FAVICON_LABEL: "Favicon",
          FAVICON_DESC: "Ícone da aba do navegador",
        },
        COLORS: {
          SECTION_TITLE: "Cores Gerais",
          THEME: "Tema",
          BACKGROUNDS: "Fundos",
          TEXTS: "Textos",
          BORDERS: "Bordas",
          STATUS: "Status",
        },
        PREVIEW: {
          REAL_TIME: "Preview em tempo real",
          GENERAL: "Geral",
          LOGIN: "Login",
          BOTH: "Ambos",
          LOGIN_SCREEN: "Tela de Login",
          GENERAL_PREVIEW: "Preview Geral",
        },
        ERRORS: {
          REQUIRED_FIELDS: "Preencha os campos obrigatórios: licensedId, domain e platformName",
        },
      },
    },
    EQUIPMENT_COMMAND_ACCESS_LEVELS: {
      TITLE: "Vínculo de Comandos a Nível de Acesso",
      CARD_TITLE: "Níveis de acesso dos comandos",
    },

    TOOLTIPS: {
      DASHBOARD: "Visão geral de todos os dados da frota, incluindo status dos veículos, KPIs e gráficos de análise.",

      DASHBOARD_CARDS_ACTIVE_VEHICLES: "Indica a quantidade de veículos rastreados, conforme o filtro de grupo selecionado.",
      DASHBOARD_CARDS_TOTAL_ODOMETER: "Indica a soma dos odômetros dos veículos rastreados, conforme filtros de grupo e período selecionados.",
      DASHBOARD_CARDS_KM_BUSINESS_HOURS: "Indica a soma dos odômetros dos veículos rastreados que circularam dentro do horário comercial (padrão: segunda a sexta, das 08h às 18h). Conforme filtros de grupo e período selecionados.",
      DASHBOARD_CARDS_KM_OUTSIDE_HOURS: "Indica a soma dos odômetros dos veículos que circularam fora do horário comercial (padrão: antes das 8h ou após 18h em dias úteis, qualquer horário nos finais de semana). Conforme filtros de grupo e período selecionados.",
      DASHBOARD_CARDS_ENGINE_TIME: "Indica a soma dos tempos dos veículos ligados e em movimento, conforme filtros de grupo e período selecionados.",
      DASHBOARD_CARDS_IDLE_TIME: "Indica a soma dos tempos dos veículos ligados, porém parados (considerado a partir de 2 minutos no mesmo local). Conforme filtros de grupo e período selecionados.",
      DASHBOARD_CARDS_OFF_TIME: "Indica a soma dos tempos dos veículos desligados, conforme filtros de grupo e período selecionados.",
      DASHBOARD_CARDS_SPEED_LIMIT_DISTANCE: "Indica a quantidade de ocorrências registradas acima da velocidade regulamentar da via, conforme filtros de grupo e período selecionados.",
      DASHBOARD_CARDS_COMPANY_SPEED_LIMIT_DISTANCE: "Indica a quantidade de ocorrências registradas acima da velocidade definida pela empresa (padrão urbano: 80 km/h, padrão rodoviário: 120 km/h), conforme filtros de grupo e período selecionados.",

      DASHBOARD_CHARTS_VEHICLE_STATUS: "Demonstra a atividade dos veículos da frota (ligado, desligado, parado, em movimento) e pontua situações anômalas no rastreamento como problemas de GPS, atrasos de posicionamento e comunicação com o rastreador.",
      DASHBOARD_CHARTS_QUICK_CONTACTS: "Permite que o usuário tenha as opções de contato da Movyx na palma da mão. Contatos da filial regional, consultor Movyx e central de atendimento 24/7.",
      DASHBOARD_CHARTS_DRIVERS_RANKING: "Ranking de motorista ou veículo que pontua o condutor/veículo com a pior dirigibilidade, baseado em eventos e seus respectivos pesos. Útil para identificar comportamentos de risco na frota.",
      DASHBOARD_CHARTS_MOST_ACTIVE_VEHICLES: "Indicadores que apontam os veículos com maior circulação (veículo ligado em movimento). Métrica útil para equalizar o uso da frota e aumentar sua eficiência operacional.",
      DASHBOARD_CHARTS_MOST_IDLE_VEHICLES: "Fornece métricas sobre veículos com maior ociosidade (ligados sem movimento). Útil para redução de custos operacionais, aumento de eficiência e planejamento de manutenções.",
      DASHBOARD_CHARTS_OUTSIDE_HOURS_USAGE: "Indica o uso dos veículos fora do horário definido pela empresa (em km). Útil para identificar tanto uso indevido do veículo quanto situações excepcionais na operação.",
      DASHBOARD_CHARTS_WEEKLY_CIRCULATION: "Indicador que demonstra a soma da circulação dos veículos da frota por período (em km), segmentado por dias da semana (segunda a domingo).",
      DASHBOARD_CHARTS_SPEED_LIMIT_EXCESS: "Demonstra o quanto os veículos estão extrapolando a velocidade, seja a definida pela empresa ou a velocidade regulamentar da via. Útil para gestão de segurança.",

      MINHA_FROTA: "Consulte o status em tempo real de todos os veículos da sua frota com informações detalhadas de localização e operação. Visualize em mapa ou grid com filtros por placa, grupo, status, ignição, velocidade, motorista e localização.",
      POSICOES_DETALHADAS: "Acompanhe a posição detalhada de cada veículo com histórico de movimentação desde o início do dia. Permite aplicar filtros por outros períodos e realizar ações específicas.",
      GRID_JOURNEY_WORK: "Analise as jornadas de trabalho dos veículos com informações sobre rotas, durações e eficiência operacional. Visualize detalhes do trajeto de origem ao destino.",
      GRID_SPEED_CONTROL: "Monitore eventos de excesso de velocidade e velocidade acima do limite, gerando relatórios de segurança. Filtre por agrupamento de veículos, tipo de ocorrência e período de análise.",
      GRID_VISIT_AMOUNT: "Acompanhe pontos de visita e parada com análise de tempo gasto em cada local. Identifique quais veículos realizaram visitas com início, fim e duração de cada uma.",
      GRID_PERIOD_VISITS: "Visualize visitas agrupadas por período com estatísticas e métricas de desempenho. Filtre por tempo mínimo de permanência e período específico.",
      GRID_PROTOCOLS: "Consulte protocolos e procedimentos registrados para cada evento de operação. Inclui protocolos automáticos, gerados por evento ou por atendimento.",
      APELIDO: "Permite o usuário atribuir o Nome de um veículo, como um código de frota ou uma descrição",
      RADAR: "Visualização em mapa que se atualiza automaticamente com todos os veículos ativos, filtrado por grupos e períodos. Abre em janela independente do navegador.",
      VEICULO_MAIS_PROXIMO: "Funcionalidade de geolocalização que permite pesquisar o veículo mais próximo a um endereço, outro veículo ou ponto de visita. Inclui informações de distância e tempo de chegada.",
      CONTROL_POINT: "Gerencie pontos de controle e acesso, monitorando passagens e eventos associados. Permite cadastrar locais onde os veículos realizam paradas e visitas.",
      ELETRONIC_FENCES: "Configure e monitore cercas eletrônicas (geofences) para alertas de entrada e saída de zonas. Usada para segurança, controle de frotas e gestão logística.",
      RISK_AREA: "Identifique áreas de risco com base em histórico de eventos e comportamento de condução. O sistema sinaliza quando veículos entram ou saem da área delimitada.",
      VEHICLES_CONFIGURATION: "Configure propriedades e parâmetros dos veículos da frota, horários comerciais, limites de velocidade e outras referências.",
      DRIVERS_MANAGEMENT: "Gerencie dados de motoristas, documentos, histórico de eventos e desempenho. Inclua dados complementares e defina permissões de condução por veículo.",
      USERS_GROUPS: "Organize usuários em grupos para controle de acesso e permissões. Usuário principal pode criar e gerenciar acessos limitados de outros usuários.",
      VEHICLES_GROUPS: "Agrupe veículos por critérios operacionais para análise e gerenciamento simplificado. Configure parâmetros específicos, gere relatórios automatizados e defina referências.",
      VEHICLE_DETAILS: "Informações detalhadas do veículo incluindo especificações técnicas, documentação, histórico e localização. Visualize nível de bateria, status da ignição, velocidade, odômetro e street view.",
      DRIVER_DETAILS: "Dados completos do motorista com licenças, histórico de eventos e desempenho. Inclua informações complementares e permissões de condução.",
      REPORTS: "Gere relatórios customizados com dados de operação, segurança e eficiência da frota. Inclui deslocamento, posicionamento, distância percorrida, visitas e controle de velocidade.",
      SETTINGS: "Configure preferências do sistema, notificações e parâmetros de operação. Altere horários comerciais, limites de velocidade e outras configurações da frota.",
      USER_PROFILE: "Gerencie seu perfil de usuário, alterando dados pessoais e preferências. Também permite alterar senha e gerenciar informações da conta.",
      HELP: "Central de ajuda com documentação, tutoriais e suporte técnico. Acesso a informações sobre todas as funcionalidades do sistema.",
      POINT_OF_VISIT: "Cadastre locais onde os veículos realizam paradas e visitas (fornecedores, clientes, pontos de interesse). Facilita identificação quando endereço é substituído pelo nome do ponto.",
      USER_PROFILE_CLIENT: "Defina informações do usuário como dados pessoais e preferências de acesso.",
      COMPANY_INFO: "Exiba informações da empresa cadastrada, permitindo consultar os dados do registro.",
      CHANGE_PASSWORD: "Altere a senha do sua conta de usuário para maior segurança.",
      PROTOCOLS: "Tela que permite a consulta de protocolos gerados, sejam protocolos automáticos, gerados por evento, ou por atendimento.",
      LOGS: "Registro de Atividades (Log) - tela que permite realizar consultas de todas as atividades realizadas pelo usuário no sistema Movyx Safe.",
      GROUPS: "Tela que permite criar, editar e administrar Grupos de Veiculos e sua configuração específica, permitindo a geração de relatórios automatizados, e configuração de parâmetros e referências para relatórios e dashboards.",
      BIND_VEHICLES: "Permite alocar um veículo a um grupo. Também é possível realocar os veículos de um grupo para outro.",
      GROUP_USERS: "Gerencia a permissão dos usuários (criados dentro da conta do cliente) para visualizar e administrar grupos específicos.",
      POSITION: "Função que permite acessar o histórico de posicionamento do veículo para um período especificado.",
      DISTANCE: "Esta consulta permite determinar a distância total percorrida por um veículo em um intervalo de tempo específico, registrando os pontos de partida e chegada, incluindo seus respectivos locais de início e término.",
      MAINTENANCE_ITEM: "Tela usada para cadastrar e gerenciar os itens de manutenção, permitindo criar, editar, inativar e visualizar todos os componentes que fazem parte dos serviços.",
      MAINTENANCE_SCHEDULING: "Tela destinada ao agendamento das manutenções, onde o usuário define datas, veículos ou equipamentos, responsáveis e a periodicidade das intervenções que precisam ser realizadas.",
      MAINTENANCE_SHIPPING: "Tela voltada ao controle de envio e recebimento de peças ou equipamentos para manutenção externa, registrando remessas, transportadoras, prazos e o status logístico de cada item.",
      MAINTENANCE_REGISTER: "Tela responsável pelo registro detalhado das manutenções realizadas, incluindo descrição do serviço, peças utilizadas, horas trabalhadas, custos e o técnico responsável pela execução.",
      MAINTENANCE_PENDING: "Tela que lista todas as manutenções pendentes, permitindo filtrar, priorizar e acompanhar atividades que ainda precisam ser executadas, aprovadas ou agendadas no fluxo de manutenção.",
      MAINTENANCE_COMPLETED: "Tela que apresenta o histórico de manutenções concluídas, facilitando consultas, auditorias e a geração de relatórios sobre desempenho, custos e histórico dos equipamentos ou veículos.",
      MAINTENANCE_REGISTER_KM: "Tela destinada ao registro e consulta do odômetro dos veículos, permitindo cadastrar leituras de KM com data e hora, e consultar o histórico de registros por veículo e período.",
      EQUIPMENT_COMMAND_ACCESS_LEVELS: "Tela destinada ao vínculo de comandos a níveis de acesso, definindo quais perfis de usuário têm permissão para executar cada comando nos equipamentos cadastrados.",
    },
  },
};
